import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/compat/app";
import { functions } from "../main";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import requests from './requests.js'
import router from '../router'
import {
  doc,
  or,
  getDoc,
  getFirestore,
  getDocs,
  updateDoc,
  serverTimestamp,
  collection,
  where,
  whereEqualTo,
  query,
  setDoc,
  arrayUnion,
  arrayRemove
} from 'firebase/firestore';
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from 'firebase/functions';
// import { firebaseMutations } from 'vuexfire';

import auth from './auth';
import groups from './groups';
import group from './group';
import orders from './orders';
// import requests from './requests';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    requests: requests,
    auth: auth,
    groups: groups,
    group: group,
    orders: orders,
    onboarded: "",
  },
  key: {
    db: null
  },
  state: {
    loadedItems: [],
    loadedReviews: [],
    loadedRooms: [],
    db: null,
    loading: false,
    error: null,
    verifier: "",
    tokens: [],
    booking: null,
    paymentSuccess: false,
    paymentVerificationSuccess: false,
    verificationSuccess: false,
    user: null,
    // loadedBookings: [],
    loadedUserBookings: [],
    reviewSuccess: false,
    acceptDialog: false,
  },
  mutations: {

    SET_BOOKING(state, payload) {
      state.booking = payload;
      // state.bookingID.push(payload)
    },

    ADD_TOKEN(state, token) {
      state.tokens.push(token)
    },

    STORE_VERIFIER(state, payload) {
      state.verifier = payload;
    },

    setUser(state, payload) {

      // console.log('setUser mutation', payload)
      console.log('in the setter', state.user)
      state.user = payload;

    },
    setOnboarding(state, payload) {
      state.onboarded = payload;
    },
    setCreatedItemKey(state, payload) {
      state.createdItemKey = payload;
    },
    setLoadedItems(state, payload) {

      // for (let i = 0; i < payload.length; i++) {
      //   if (payload[i].createdAt.seconds > 1651336439) {

      //     for (let x = 0; x < payload[i].images.length; x++) {
      //       payload[i].images[x].src = payload[i].images[x].src
      //     }
      //   }
      // }
      state.loadedItems = payload;
    },
    setLoadedReviews(state, payload) {

      state.loadedReviews = payload;
    },

    setLoadedRooms(state, payload) {

      state.loadedRooms = payload;
    },
    setLoadedBookings(state, payload) {
      // for (let i = 0; i < payload.length; i++) {
      //   if (payload[i].createdAt.seconds > 1651336439) {

      //     for (let x = 0; x < payload[i].images.length; x++) {
      //       payload[i].images[x].src = payload[i].images[x].src.replace(/.png/g, "_500x500.png")
      //     }
      //   }
      // }
      // console.log(payload)
      state.loadedBookings = payload;
    },

    setLoadedUserBookings(state, payload) {
      state.loadedUserBookings = null;
      state.loadedUserBookings = payload;
      // console.log('in the setter', state.loadedUserBookings)
      //log each loadedUserBookings ids and statuses
      // for (let i = 0; i < payload.length; i++) {
      //   console.log(payload[i].id, payload[i].status)
      // }

    },
    setUserprofile(state, payload) {
      // console.log('payload', payload)
      // console.log('state', state.user)
      //add payload to the user state don't overwrite existing
      state.user = { ...state.user, ...payload };
      // console.log('state', state.user)

    },

    setNewLoadedUserBooking(state, payload) {
      state.newLoadedUserBooking == payload;

      // console.log(' booking to be added in the setter', payload);

      //add the new booking to the loadedUserBookings list
      state.loadedUserBookings.push(payload)
      // console.log('in the setter', state.loadedUserBookings)


    },

    setLoadedBooking(state, payload) {
      state.loadedBooking = payload;
    },
    createBooking(state, payload) {
      // for (let i = 0; i < payload.length; i++) {
      //   if (payload[i].createdAt.seconds > 1651336439) {

      //     for (let x = 0; x < payload[i].images.length; x++) {
      //       payload[i].images[x].src = payload[i].images[x].src.replace(/.png/g, "_500x500.png")
      //     }
      //   }
      // }
      state.loadedBookings.push(payload);
    },
    savePriorityBuySell(state, payload) {
      // for (let i = 0; i < payload.length; i++) {
      //   if (payload[i].createdAt.seconds > 1651336439) {

      //     for (let x = 0; x < payload[i].images.length; x++) {
      //       payload[i].images[x].src = payload[i].images[x].src.replace(/.png/g, "_500x500.png")
      //     }
      //   }
      // }
      state.loadedPriorityBuySell.push(payload);
    },
    createItem(state, payload) {

      for (let x = 0; x < payload.images.length; x++) {
        payload.images[x].src = payload.images[x].src.replace(/.png/g, "_500x500.png")
      }

      state.loadedItems.unshift(payload);
    },
    createSalesItem(state, payload) {
      // state.loadedUser = payload;
    },
    // verifyUser(state, payload) {
    //   state.user.push(payload);
    // },
    setLoadedUser(state, payload) {
      state.loadedUser = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setAcceptDialog(state, payload) {
      state.acceptDialog = payload;
    },
    setPaymentSuccess(state, payload) {
      state.paymentSuccess = payload;
    },
    setPaymentVerificationSuccess(state, payload) {
      state.paymentVerificationSuccess = payload;
    },
    setVerificationSuccess(state, payload) {
      state.verificationSuccess = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },
    clearReviewSuccess(state) {
      state.reviewSuccess = null;
    },
    clearLoadedUserBookings(state) {
      console.log('clearing loaded user bookings')
      state.loadedUserBookings = null;
      console.log('cleared loaded user bookings', state.loadedUserBookings)
    },
    clearUserBookings(state) {
      state.error = null;
    },
    updateItem(state, payload) {
      const item = state.loadedItems.find(item => {
        return item.id === payload.id;
      });
      if (payload.itemName) {
        item.itemName = payload.itemName;
      }
      if (payload.itemDescription) {
        item.itemDescription = payload.itemDescription;
      }
      if (payload.dailyFee) {
        item.dailyFee = payload.dailyFee;
      }
      if (payload.monthlyFee) {
        item.monthlyFee = payload.monthlyFee;
      }
      if (payload.weeklyFee) {
        item.weeklyFee = payload.weeklyFee;
      }
      if (payload.deposit) {
        item.deposit = payload.deposit;
      }
      if (payload.deliveryFee) {
        item.deliveryFee = payload.deliveryFee;
      }
      if (payload.status) {
        item.status = payload.status;
      }
      if (payload.area) {
        item.area = payload.area;
      }
      if (payload.location) {
        item.location = payload.location;
      }
    },

    updateBooking(state, payload) {
      console.log('Live update of booking')
      const booking = state.loadedUserBookings.find(booking => {
        return booking.id === payload.id;
      });
      if (payload.status) {
        booking.status = payload.status;

        if (payload.status === 'awaiting-payment') {
          //dispatch acceptDialog
          console.log('dispatching acceptDialog')
          state.acceptDialog = true;
        }
      }
      if (payload.images) {
        booking.qualityImages = payload.images;
      }

      console.log('Live update of loadedUserBooking', booking, state.loadedUserBookings)

      if (booking.status === 'completed' || booking.status === 'returndB' || booking.status === 'returnedL') {
        //set reviewSuccess to true
        state.reviewSuccess = true;

        console.log('reviewSuccess', state.reviewSuccess)
      }

      for (let i = 0; i < state.loadedUserBookings.length; i++) {
        console.log(state.loadedUserBookings[i].id, state.loadedUserBookings[i].status)
      }

      //set loading to false
      state.loading = false;
    },

  },


  actions: {
    setBooking({ commit }, payload) {
      // set the payload to the store
      console.log('setBooking', payload)
      commit('SET_BOOKING', payload)
    },

    setVerifier({ commit }, number) {
      commit('STORE_VERIFIER', number)
    },


    setUser({ commit }, payload) {
      commit("setUser", payload);
    },
    signInWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .catch(error => alert("🤕" + error.message))
        .then(data => console.log(data.user, data.credential.accessToken))
        .then(cred => {
          return firebase
            .firestore()
            .collection("users")
            .doc(cred.user.uid)
            .set({
              uid: user.uid,
              email: user.email,
              displayName: user.displayName,
              photoURL: user.photoURL
            })
            .then(
              firebase
                .firestore()
                .collection("users")
                .doc(cred.user.uid)
                .collection("privateData")
                .doc(cred.user.uid)
                .set({
                  acceptPrivacyPolicy: "true",
                  acceptTermsAndConditions: "true",
                  firstName: user.getDisplayName(),
                  displayName: user.displayName,
                  lastName: user.getDisplayName(),
                  email: user.email,
                  uid: user.uid,
                  onboarded: false
                })
            )
            .then(
              firebase
                .firestore()
                .collection("crmData")
                .doc(cred.user.uid)
                .set({
                  firstName: user.getDisplayName(),
                  lastName: user.getDisplayName(),
                  email: auth.currentUser.email
                })
            );
        });
      onCreateItem();
      submitBooking();
      this.$store.dispatch('loadUser', cred.user.id);
    },

    fetchUserData({ commit, getters }) {
      commit("setLoading", true);
      firebase
        .firestore()
        .ref("/users/" + getters.user.id + "/registrations/")
        .once("value")
        .then(data => {
          const dataPairs = data.val();
          let registeredItems = [];
          let swappedPairs = {};
          for (let key in dataPairs) {
            registeredItems.push(dataPairs[key]);
            swappedPairs[dataPairs[key]] = key;
          }
          const updatedUser = {
            id: getters.user.id
          };
          commit("setLoading", false);
          commit("setUser", updatedUser);
        })
        .catch(error => {
          console.log(error);
          commit("setLoading", false);
        });
    },



    async loadUser({ commit }, payload) {

      const db = getFirestore();
      const userRef = doc(db, "users", payload);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        console.log("public data:", docSnap.data());

        var publicData = docSnap.data();

        const privateRef = doc(db, "users", payload, "privateData", payload);
        const privateSnap = await getDoc(privateRef);

        if (privateSnap.exists()) {
          console.log("load User Private Document data:", privateSnap.data());

          var privateData = privateSnap.data();

          var user = {
            ...publicData,
            ...privateData
          };

          commit("setUser", user);
        } else {
          console.log("Private Data not reached!");
          var user = {
            ...publicData
          };
          commit("setUser", user);
        }
        console.log("load User Document data:", user);
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }


    },

    loadProfile({ commit }) {
      // this.$store.dispatch('setDb',firebase.firestore().collection('items'))
      commit("setLoading", true);
      firebase
        .firestore()
        .collection("users")
        .doc(commit)
        .get()
        .then(function (querySnapshot) {
          const items = [];
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var o = doc.data();

            o.id = doc.id;
            items.push(o);
          });
          commit("setLoadedItems", items);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },

    loadItems({ commit }) {
      // this.$store.dispatch('setDb',firebase.firestore().collection('items'))
      commit("setLoading", true);
      firebase
        .firestore()
        .collection("items")
        .orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          const items = [];
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var o = doc.data();

            o.id = doc.id;
            items.push(o);
          });
          commit("setLoadedItems", items);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },

    loadRooms({ commit }, payload) {
      console.log('loading rooms')
      console.log(payload)
      return new Promise(async (resolve, reject) => {
        try {
          let q = []
          // const db = f
          const roomsRef = firebase.firestore().collection('chatrooms');
          roomsRef.where("userIDs", "array-contains", payload.id)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                console.log(doc.id, " => ", doc.data());
                let a = doc.data();

                a.id = doc.id
                q.push(a)

              }

              );

              commit("setLoadedRooms", q)
              resolve(q)
              console.log('loaded q rooms:', q)
            })
            .catch((error) => {
              console.log("Error getting documents: ", error);
            });

          // const snap = await firebase
          //   .firestore()
          //   .collection('users')
          //   .doc(payload.id)
          //   .get()

          // if (snap.exists && snap.data().chatrooms) {
          //   const userRooms = []
          //   const db = firebase.firestore()

          //   for (let i = 0; i < snap.data().chatrooms.length; i++) {
          //     console.log('has room ' + snap.data().chatrooms[i])

          //     const getRoom = query(
          //       collection(db, "chatrooms"),
          //       where("roomId", "==", snap.data().chatrooms[i])
          //     )

          //     const roomQuerySnapshot = await getDocs(getRoom)

          //     roomQuerySnapshot.forEach((doc) => {
          //       const a = doc.data()
          //       a.id = doc.id
          //       userRooms.push(a)
          //     })
          //   }
          //   console.log(userRooms)

          //   commit("setLoadedRooms", userRooms)
          //   resolve(userRooms)
          // } else {
          //   console.log("No such document!")
          //   resolve([])
          // }
        } catch (error) {
          console.error(error)
          reject(error)
        }
      })
    },


    loadReviews({ commit }) {
      // this.$store.dispatch('setDb',firebase.firestore().collection('items'))
      // commit("setLoading", true);
      firebase
        .firestore()
        .collection("reviews")
        .get()
        .then(function (querySnapshot) {
          const reviews = [];
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var o = doc.data();

            o.id = doc.id;
            reviews.push(o);
          });
          // console.log('Loaded reviews: ', reviews)
          commit("setLoadedReviews", reviews);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    clearError({ commit }) {
      commit("clearError");
    },

    loadBookings({ commit, getters, context }) {

      // console.log('loadBookings', getters.user.id);

      commit("setLoading", true);
      firebase
        .firestore()
        .collection("bookings")
        .orderBy("createdAt", "desc")
        // .where("borrowerID", "==", firebase.auth.currentUser.uid)
        .get()
        .then(function (querySnapshot) {
          const bookings = [];
          querySnapshot.forEach(function (doc) {
            var o = doc.data();
            o.id = doc.id;
            bookings.push(o);
          });
          commit("setLoadedBookings", bookings);
          commit("setLoading", false);
        })
        .catch(function (error) {
          // console.log("Error getting documents: ", error);
        });
    },
    clearError({ commit }) {
      commit("clearError");
    },

    loadBooking({ commit, getters, context }) {
      commit("setLoading", true);
      firebase
        .firestore()
        .collection("bookings")
        .orderBy("createdAt", "desc")
        // .where("borrowerID", "==", firebase.auth.currentUser.uid)
        .get()
        .then(function (querySnapshot) {
          const bookings = [];
          querySnapshot.forEach(function (doc) {
            var o = doc.data();
            o.id = doc.id;
            bookings.push(o);
          });
          commit("setLoadedBooking", booking);
          commit("setLoading", false);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    clearError({ commit }) {
      commit("clearError");
    },

    //USER REVIEW

    async createReview(context, payload) {
      // context.commit("setLoading", true);
      // context.commit("clearError");


      console.log('review payload: ', payload)
      try {
        const review = {
          /* this needs to be changed to get first name and first letter of last name */
          bookingId: payload.bookingId,
          itemId: payload.itemId,
          itemName: payload.itemName,
          lenderID: payload.lenderID,
          lenderName: payload.lenderName,
          borrowerName: payload.borrowerName,
          borrowerID: payload.borrowerID,
          reviewerAvatar: firebase.auth().currentUser.photoURL,
          createdAt: new Date().toLocaleString(),
          date: new Date().toLocaleDateString(),
          time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit"
          }),
          rating: payload.rating,
          review: payload.review,
          reviewType: payload.reviewType

        };

        let id;
        var db = firebase.firestore();

        await db
          .collection("reviews")
          .add(review)
          .then(data => {
            console.log(data);
            id = data.id;
          });
        review.id = id;


        context.commit("setLoading", false);


      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);

      }

    },


    async createRoom(context, payload) {
      // context.commit("setLoading", true);
      // context.commit("clearError");


      console.log('room payload: ', payload)
      try {

        firebase
          .firestore()
          .collection("chatrooms")
          .doc(payload.roomId)
          .set({
            roomId: payload.roomId,
            unreadCount: payload.unreadCount,
            lastMessage: payload.lastMessage,
            index: payload.index,
            users: payload.users,
            userIDs: payload.userIDs
          })

        context.commit("setLoading", false);
        console.log('success')

        return 'success'


      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);
        console.log('error: ', error)
        return 'error'
      }

    },

    async createMessage(context, payload) {
      // context.commit("setLoading", true);
      // context.commit("clearError");


      console.log('room payload: ', payload)
      try {

        firebase
          .firestore()
          .collection("messages")
          .doc(payload.messageId)
          .set({
            messageId: payload.messageId,
            _id: payload._id,
            roomId: payload.roomId,
            unsafeContent: payload.unsafeContent,
            senderId: payload.senderId,
            receiverId: payload.receiverId,
            receiverId: payload.receiverId,
            timestamp: payload.timestamp,
            date: payload.date,
            distributed: true

          })

        context.commit("setLoading", false);
        console.log('success')

        return 'success'


      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);
        console.log('error: ', error)
        return 'error'
      }

    },

    //UPDATE BOOKING STATUS
    async updateBookingData({ commit, getters }, payload) {
      console.log('update booking')
      const id = payload.id;
      const updateObj = {};
      if (payload.status) {
        updateObj.status = payload.status;
      }
      if (payload.images) {
        updateObj.qualityImages = payload.images;
      }
      if (payload.updatedAt) {
        updateObj.updatedAt = payload.updatedAt;
      }
      if (payload.QAimages) {
        updateObj.QAimages = payload.QAimages;
      }
      if (payload.borrower_manual_payreq_received) {
        updateObj.borrower_manual_payreq_received = payload.borrower_manual_payreq_received;
      }
      if (payload.lender_manual_payreq_received) {
        updateObj.lender_manual_payreq_received = payload.lender_manual_payreq_received;
      }



      await console.log("update obj was", updateObj);
      await firebase
        .firestore()
        .collection("bookings")
        .doc(id)
        .update(updateObj)
        .then(async () => {
          //   //send email
          //   const callable = functions.httpsCallable("bookingUpdate");
          //   console.log(this.user);
          //   const self = this;

          //   commit("setLoading", false);
          await commit("updateBooking", payload);

          commit("setLoading", false);

          //update loadedUserBookings
          // await commit("updateBooking", payload);
        })
        .catch(error => {
          console.log("updateBooking error:", error);
          commit("setLoading", false);
        });


    },

    // async generateKey() {
    //   console.log('generate step 1')

    //   firebase.functions().useEmulator("localhost", 5001);

    //   var addMessage = firebase
    //   .functions()
    //   .httpsCallable("genKey");

    //   setUserage();
    // },

    async loadUserBookings({ commit, state }, payload) {

      // commit("clearLoadedUserBookings");

      commit("setLoading", true);

      console.log('load User Bookings payload UserID', payload)

      const userId = payload

      const bookings = [];

      const db = getFirestore();

      const bookingsPlaced = query(collection(db, "bookings"), where("borrowerID", "==", userId));

      const borrowingQuerySnapshot = await getDocs(bookingsPlaced);

      borrowingQuerySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        var a = doc.data();
        a.id = doc.id;
        bookings.push(a);

      });

      const bookingsReceived = query(collection(db, "bookings"), where("lenderID", "==", userId));

      const lendingQuerySnapshot = await getDocs(bookingsReceived);

      lendingQuerySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        var b = doc.data();
        b.id = doc.id;
        bookings.push(b);

      });

      console.log('bookings', bookings)

      commit("setLoadedUserBookings", bookings);

      commit("setLoading", false);

    },


    clearError({ commit }) {
      commit("clearError");
    },

    async createBooking(context, payload, getters) {
      context.commit("setLoading", true);
      context.commit("clearError");

      console.log("here @ payload", payload);



      console.log('user', this.getters.user)

      const db = getFirestore();
      // //set user document from firestore
      // const userDoc = doc(db, "users", this.getters.user.id);
      // const userDocSnap = await getDoc(userDoc);

      // console.log('user doc', userDocSnap.data())

      // var userName = userDocSnap.data().firstName;
      if (this.getters.user.firstName) {
        var userName = this.getters.user.firstName
      }
      else if (this.getters.user.name) {
        var userName = this.getters.user.name
        console.log('user name', userName)
      }

      else if (!this.getters.user.name && !this.getters.user.firstName) {
        var userName = 'User'
      }

      console.log(userName)


      const bookingRef = doc(collection(db, "bookings"));


      let booking = {
        itemID: payload.itemID,
        itemName: payload.itemName,
        lenderID: payload.lenderID,
        borrowerName: userName,
        borrowerID: this.getters.user.id,
        createdAt: serverTimestamp(),
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        }),
        images: payload.images,
        dateRange: payload.dateRange,
        startDate: payload.startDateText,
        endDateTS: payload.endDateTS,
        startDateTS: payload.startDateTS,
        endDate: payload.endDateText,
        endDateTS: payload.endDateTS,
        startDateTS: payload.startDateTS,
        suburb: payload.suburb,
        deposit: payload.deposit,
        total: payload.total,
        status: payload.status,
        delivery: payload.delivery,
        comment: payload.comment,
        serviceFee: payload.serviceFee,
        totalServiceFee: payload.totalServiceFee,
        lenderReceivable: payload.lenderReceivable,
        lenderName: payload.lenderName,
        rentalFee: payload.rentalFee,
        deliveryFee: payload.deliveryFee,
        subTotal: payload.subTotal,
        discount: payload.discount,
        dailyFee: payload.dailyFee,
        dailyEffectiveRate: payload.dailyEffectiveRate,
        id: bookingRef.id
      };

      console.log(booking)

      //update loadedUserBookings to include new booking
      context.commit("setNewLoadedUserBooking", booking);

      await setDoc(bookingRef, booking);

      context.commit("createBooking", booking);
      // call loadBookings to update the store
      context.dispatch("loadBookings");
      context.dispatch('loadUserBookings', context.getters.user.id);
      context.commit("setLoading", false);
      console.log("Document written with ID: ", bookingRef.id);

    },




    //////////////////////////////////////////////////////////////////////////
    async createItem(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");

      try {
        console.log("starting createItem here");
        const item = {
          /* this needs to be changed to get first name and first letter of last name */

          created_by: firebase
            .auth()
            .currentUser.displayName,
          itemName: payload.itemName,
          location: payload.location,
          images: payload.images,
          //  imageUrl: payload.imageUrl,
          itemDescription: payload.itemDescription,
          condition: payload.condition,
          minPeriod: payload.minPeriod,
          // minDays: payload.minDays,
          createdAt: new Date(),
          currentValue: payload.currentValue,
          deposit: payload.deposit,
          dailyFee: payload.dailyFee,
          status: "available",
          termsAccepted: "yes",
          availabilty: true,
          // bookingStatus: 'Not Booked',
          deliveryFee: payload.deliveryFee,
          monthlyFee: payload.monthlyFee,
          weeklyFee: payload.weeklyFee,
          category: payload.category,
          area: payload.area,
          // userID: context.getters.user.id
        };
        // id is ommitted from upload file location
        let id;
        var db = getFirestore();

        // if (location.hostname === "localhost") {
        //   db.useEmulator("localhost", 8080);
        // }
        // const fbResponse =
        await db
          .collection("items")
          .add(item)
          .then(data => {
            console.log(data);
            id = data.id;
          });
        item.id = id;

        const callable = functions.httpsCallable("newItem");
        const response = await callable({
          email: context.getters.user.email
        });
        context.commit("createItem", item);
        context.commit("setLoading", false);
        //TODO

        //resolve();

        // catch errors
      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);
        console.log(error.message);
        reject(error);
      }
    },


    async createSalesItem(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          context.commit("setLoading", true);
          context.commit("clearError");

          console.log("starting createItem here");
          const item = {
            /* this needs to be changed to get first name and first letter of last name */

            created_by: firebase.auth().currentUser.displayName,
            itemName: payload.itemName,
            address: payload.address,
            suburb: payload.suburb,
            postalCode: payload.postalCode,
            province: payload.province,
            country: payload.country,
            lat: payload.lat,
            long: payload.long,
            itemDescription: payload.itemDescription,
            condition: payload.condition,
            // minDays: payload.minDays,
            createdAt: new Date(),
            termsAccepted: "yes",
            status: "pending-approval",
            city: payload.city,
            collection: payload.collection,
            price: payload.price,
            category: payload.category,
            itemLength: payload.itemLength,
            itemWidth: payload.itemWidth,
            itemHeight: payload.itemHeight,
            itemWeight: payload.itemWeight,

          };
          // id is ommitted from upload file location
          let id;
          var db = firebase.firestore();

          // if (location.hostname === "localhost") {
          //   db.useEmulator("localhost", 8080);
          // }
          const data = await db.collection("salesItems").add(item);
          console.log(data);
          id = data.id;
          item.id = id;

          const callable = functions.httpsCallable("newItem");
          const response = await callable({
            email: context.getters.user.email
          });
          context.commit("createSalesItem", item);
          context.commit("setLoading", false);
          //TODO

          resolve(item);
        } catch (error) {
          context.commit("setLoading", false);
          context.commit("setError", error);
          console.log(error.message);
          reject(error);
        }
      });
    },

    async updateUser(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");

      try {
        console.log("starting update User");

        const user = {
          // uuid: cred.user.uid,asxjbh
          suburb: payload.suburb,
          id: context.getters.user.id
        };
        const phone = {
          phoneNumber: payload.phone
        };
        const update = {
          phoneNumber: payload.phone,
          suburb: payload.suburb
        };

        // id is ommitted from upload file location
        let id = context.getters.user.id;
        // id: user.user.uid,
        // const fbResponse =
        await firebase
          .firestore()
          .collection("users")
          .doc(context.getters.user.id)
          // .collection("privateData")
          // .doc(context.getters.user.id)
          .set(user, { merge: true }).then;
        await firebase
          .firestore()
          .collection("users")
          .doc(context.getters.user.id)
          .collection("privateData")
          .doc(context.getters.user.id)
          .set(phone, { merge: true })
          .then(data => {
            console.log(data);
          }).then;
        await firebase
          .firestore()
          .collection("crmData")
          .doc(context.getters.user.id)
          .set(update, { merge: true })
          .then(data => {
            console.log(data);
          })

          .then(data => {
            console.log(data);
          });

        console.log("this is the item " + id);

        context.commit("setLoading", false);

        // catch errors
      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);
        console.log(error.message);
      }
    },

    updateUserProfile(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");
      //update user state with the payload
      context.commit("setUserprofile", payload);
    },



    async updateUserChat(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");

      try {
        console.log("starting update User");


        const db = getFirestore();

        // id is ommitted from upload file location
        let id = context.getters.user.id;
        // id: user.user.uid,
        // const fbResponse =
        const newChatroom = doc(db, "users", id);
        const newChatroom2 = doc(db, "users", payload.userId);

        // Atomically add a new region to the "regions" array field.
        await updateDoc(newChatroom, {
          chatrooms: arrayUnion(payload.roomId)
        });

        await updateDoc(newChatroom2, {
          chatrooms: arrayUnion(payload.roomId)
        });


        context.commit("setLoading", false);

        // catch errors
      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);
        console.log(error.message);
      }
    },


    async SendVerificationEmails(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");

      console.log("starting SendVerificationEmails");
      // LOG payload
      console.log("payload", payload);
      //set payload to booking
      const booking = payload;
      const db = getFirestore();

      //do we have user id
      console.log('doo we have user id', context.getters.user.id);
      // do we have borrower id
      console.log('doo we have borrower id', booking.borrowerID);

      if (booking.borrowerID === context.getters.user.id) {
        console.log('user is borrower');
        try {
          var borrowerMsg = firebase
            .functions()
            .httpsCallable('borrowerPaymentConfirmation');
          await borrowerMsg({
            email: booking.borrowerEmail,
            id: booking.id,
            itemName: booking.itemName,
            borrowerName: booking.borrowerName,
            lenderName: booking.lenderName,
            lenderID: booking.lenderID,
            suburb: booking.suburb,
            startDate: booking.startDate,
            endDate: booking.endDate,
            dateRange: booking.dateRange,
            delivery: booking.delivery,
            total: booking.total
          })
            .catch((error) => {
              // Getting the Error details.
              const code = error.code;
              const message = error.message;
              const details = error.details;
              console.log('error', error, code, message, details);
              // ...
            });
        } catch (error) {
          console.log('error', error);
        }

        var lenderMsg = firebase
          .functions()
          .httpsCallable('lenderPaymentConfirmation');
        await lenderMsg({
          email: booking.borrowerEmail,
          id: booking.id,
          itemName: booking.itemName,
          borrowerName: booking.borrowerName,
          lenderName: booking.lenderName,
          lenderID: booking.lenderID,
          suburb: booking.suburb,
          startDate: booking.startDate,
          endDate: booking.endDate,
          dateRange: booking.dateRange,
          delivery: booking.delivery,
          total: booking.total,
          lenderReceivable: booking.lenderReceivable,
        })
          .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.log('error', error, code, message, details);
            // ...
          });
        await updateDoc(doc(db, 'bookings', booking.id), {
          status: 'awaiting-images',
        }).then(() => {
          console.log('update Success');
          context.commit("setPaymentVerificationSuccess", true);
          //set success to true
          // router.push({ path: 'dashboard', params: { paymentSuccess: 'true' } })

          context.commit("setLoading", false);
        });
      } else if (booking.lenderID === context.getters.user.id) {
        console.log('user is lender');
        //send Payment Emails
        try {
          var addMessage = firebase
            .functions()
            .httpsCallable('bookingRequestAccepted');
          addMessage({
            email: booking.borrowerEmail,
            id: booking.id,
            borrowerName: booking.borrowerName,
            itemName: booking.itemName,
          });
        } catch (e) {
          const errorMessage = 'There has been an error with your payment or  verification. Please contact support.';
          alert(errorMessage);
        }
        try {
          var bookingRef = firebase
            .firestore()
            .collection('bookings')
            .doc(booking.id);

          bookingRef.update({
            status: 'awaiting-payment',
            updatedAt: new Date(),
          })
            .then(() => {
              // router.push({ path: 'dashboard', params: { verificationSuccess: true } })'
              context.commit("setVerificationSuccess", true);
              //set success to true
              // router.push({ path: 'dashboard', params: { paymentSuccess: 'true' } })

              context.commit("setLoading", false);
            })
        } catch (e) {
          const errorMessage = error.message;
          alert(errorMessage);
        }

        // set email success to true
        // context.commit("setLoading", false);
        // context.commit("setSuccess", true);
      }
    },


    async uploadVerification(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");

      console.log(payload)

      try {
        console.log("starting uploadVerification");
        // const verificationData = {
        //   email: payload.email,
        //   fullName: payload.fullName,
        //   gender: payload.gender,
        //   phoneNumber: payload.phoneNumber,
        //   homeAddress: payload.homeAddress,
        //   identifyingDocument: payload.identifyingDocument,
        //   userID: context.getters.user.id,
        //   timestamp: serverTimestamp(),
        // };
        // id is ommitted from upload file location
        var db = getFirestore();

        const crmRef = doc(db, "crmData", context.getters.user.id);

        const userRef = doc(db, "users", context.getters.user.id)

        await updateDoc(userRef, {
          verified: true
        })

        const verifData = payload.data;
        console.log(verifData);

        updateDoc(crmRef,
          payload.data
        );

        console.log("id?", context.getters.user.id);
        console.log("payload.borrowerID", payload.borrowerID);
        console.log("payload.lenderID", payload.lenderID);

        if (payload.borrowerID === context.getters.user.id) {
          console.log('user is borrower');
          // const payRef = doc(db, "bookings", payload.bookingID);
          // await updateDoc(payRef, {
          //   status: 'awaiting-images',
          //   updatedAt: new Date(),
          // })

          context.dispatch('updateBookingData', {
            id: payload.bookingID,
            status: 'awaiting-images',
          })


          console.log('update Success', payload.bookingID);

          context.dispatch('loadUserBookings', context.getters.user.id);
          context.commit("setPaymentVerificationSuccess", true);
        }
        else if (payload.lenderID === context.getters.user.id) {
          console.log('user is lender');
          //accept the booking

          // const verifRef = doc(db, "bookings", payload.bookingID);

          // await updateDoc(verifRef, {
          //   status: 'awaiting-payment',
          //   updatedAt: new Date(),
          // })

          context.dispatch('updateBookingData', {
            id: payload.bookingID,
            status: 'awaiting-payment',
          })


          console.log('verificaation update Success', payload.bookingID);
          // context.dispatch('loadUserBookings', context.getters.user.id);
          context.commit("setVerificationSuccess", true);
        }

        context.commit("setLoading", false);

      } catch (error) {
        // context.commit("setLoading", false);
        // context.commit("setError", error);
        console.log(error.message);
      }
    },

    async uploadToken(context, payload) {


      console.log("upload refresh Token payload", payload)
      context.commit("setLoading", true);
      context.commit("clearError");

      try {
        console.log("starting uploadToken");
        // const stitchToken = payload.access_token;
        const refreshToken = payload;

        console.log('refreshToken', refreshToken);
        // const refreshedToken = payload.refreshedToken;
        // id is ommitted from upload file location
        var db = firebase.firestore();
        // connectFirestoreEmulator(db, 'localhost', 8081);

        const accRef = doc(db, "users", context.getters.user.id);

        updateDoc(accRef,
          refreshToken
        );


        // await db
        //   .collection("items")
        //   .add(item)
        //   .then(data => {
        //     console.log(data);
        //     id = data.id;
        //   });
        // item.id = id;


        // context.commit("uploadVerification", item);
        // context.commit("setLoading", false);
      } catch (error) {
        // context.commit("setLoading", false);
        // context.commit("setError", error);
        console.log(error.message);
      }
    },

    async createItem(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");

      try {
        console.log("starting createItem");
        const item = {
          /* this needs to be changed to get first name and first letter of last name */

          created_by: firebase
            .auth()
            .currentUser.displayName,
          itemName: payload.itemName,
          location: payload.location,
          city: payload.city,
          images: payload.images,
          //  imageUrl: payload.imageUrl,
          itemDescription: payload.itemDescription,
          condition: payload.condition,
          minPeriod: payload.minPeriod,
          // minDays: payload.minDays,
          createdAt: new Date(),
          currentValue: payload.currentValue,
          deposit: payload.deposit,
          dailyFee: payload.dailyFee,
          status: "pending-review",
          termsAccepted: "yes",
          availabilty: true,
          // bookingStatus: 'Not Booked',
          deliveryFee: payload.deliveryFee,
          monthlyFee: payload.monthlyFee,
          weeklyFee: payload.weeklyFee,
          category: payload.category,
          area: payload.area,
          userID: context.getters.user.id
        };
        // id is ommitted from upload file location
        let id;
        var db = firebase.firestore();

        // if (location.hostname === "localhost") {
        //   db.useEmulator("localhost", 8080);
        // }
        // const fbResponse =
        await db
          .collection("items")
          .add(item)
          .then(data => {
            console.log(data);
            id = data.id;
          });
        item.id = id;

        const callable = functions.httpsCallable("newItem");
        const response = await callable({
          email: context.getters.user.email
        });
        context.commit("createItem", item);
        context.commit("setLoading", false);
        //TODO

        //resolve();

        // catch errors
      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);
        console.log(error.message);
        reject(error);
      }
    },


    // async createSalesItem(context, payload) {
    //   context.commit("setLoading", true);
    //   context.commit("clearError");

    //   try {
    //     console.log("starting createItem");
    //     const item = {
    //       /* this needs to be changed to get first name and first letter of last name */


    //         created_by: firebase.auth().currentUser.displayName,
    //         itemName: payload.itemName,
    //         location: payload.location,
    //         //  imageUrl: payload.imageUrl,
    //         itemDescription: payload.itemDescription,
    //         condition: payload.condition,
    //         // minDays: payload.minDays,
    //         createdAt: new Date(),
    //         termsAccepted: "yes",
    //         status: "pending-approval",
    //         city: payload.city,
    //         price: payload.price,
    //         category: payload.category,
    //         area: payload.area,
    //     };
    //     // id is ommitted from upload file location
    //     let id;
    //     var db = firebase.firestore();

    //     // if (location.hostname === "localhost") {
    //     //   db.useEmulator("localhost", 8080);
    //     // }
    //     // const fbResponse =
    //     await db
    //       .collection("items")
    //       .add(item)
    //       .then(data => {
    //         console.log(data);
    //         id = data.id;
    //       });
    //     item.id = id;

    //     const callable = functions.httpsCallable("newItem");
    //     const response = await callable({
    //       email: context.getters.user.email
    //     });
    //     context.commit("createItem", item);
    //     context.commit("setLoading", false);
    //     //TODO

    //     //resolve();

    //     // catch errors
    //   } catch (error) {
    //     context.commit("setLoading", false);
    //     context.commit("setError", error);
    //     console.log(error.message);
    //     reject(error);
    //   }
    // },

    async saveToken(context, payload) {
      try {
        const token = payload.token;
        context.commit('ADD_TOKEN', token)
        // catch errors
      } catch (error) {

        console.log(error.message);
      }
    },

    async verifyUser(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");

      try {
        console.log("starting verifyUser");
        const user = {
          created_by: firebase.auth().currentUser.displayName,
          creditKycCheck: payload.credit,
          accepttermsAndConditions: payload.terms,
          // phone: payload.phone,
          POAimages: payload.POAimages,
          dontShareNumber: payload.dontShareNumber,
          IDimages: payload.IDimages,
          Selfimages: payload.Selfimages,
          verifiedAt: new Date(),
          id: context.getters.user.id,
          verified: true
        };
        const verified = {
          verified: true
        };

        // id is ommitted from upload file location
        let id = context.getters.user.id;
        // id: user.user.uid,
        // const fbResponse =
        await firebase
          .firestore()
          .collection("users")
          .doc(context.getters.user.id)
          .collection("privateData")
          .doc(context.getters.user.id)
          .set(user, { merge: true })
          .then(data => {
            console.log(data);
          }).then;
        await firebase
          .firestore()
          .collection("users")
          .doc(context.getters.user.id)
          .set(verified, { merge: true }).then;
        await firebase
          .firestore()
          .collection("crmData")
          .doc(context.getters.user.id)
          .set(user, { merge: true })
          .then(data => {
            console.log(data);
          });

        console.log("this is the item " + id);

        context.commit("setLoading", false);

        // catch errors
      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);
        console.log(error.message);
      }
    },

    async updatePreferences(context, payload) {
      context.commit("setLoading", true);
      context.commit("clearError");

      try {
        console.log("starting update Preferences");
        const user = {
          // shareNumber: payload.shareNumber,

          id: context.getters.user.id
        };
        const verified = {
          verified: true
        };

        // id is ommitted from upload file location
        let id = context.getters.user.id;
        // id: user.user.uid,
        // const fbResponse =
        await firebase
          .firestore()
          .collection("users")
          .doc(context.getters.user.id)
          .collection("privateData")
          .doc(context.getters.user.id)
          .set(user, { merge: true })
          .then(data => {
            console.log(data);
          }).then;
        await firebase
          .firestore()
          .collection("crmData")
          .doc(context.getters.user.id)
          .set(user, { merge: true })
          .then(data => {
            console.log(data);
          });

        context.commit("setLoading", false);

        // catch errors
      } catch (error) {
        context.commit("setLoading", false);
        context.commit("setError", error);
        console.log(error.message);
      }
    },

    updateItemData({ commit, getters }, payload) {
      const id = payload.id;
      const updateObj = {};
      if (payload.itemName) {
        updateObj.itemName = payload.itemName;
      }
      if (payload.itemDescription) {
        updateObj.itemDescription = payload.itemDescription;
      }
      if (payload.dailyFee) {
        updateObj.dailyFee = payload.dailyFee;
      }
      if (payload.monthlyFee) {
        updateObj.monthlyFee = payload.monthlyFee;
      }
      if (payload.weeklyFee) {
        updateObj.weeklyFee = payload.weeklyFee;
      }
      if (payload.deposit) {
        updateObj.deposit = payload.deposit;
      }
      if (payload.category) {
        updateObj.category = payload.category;
      }
      if (payload.deliveryFee) {
        updateObj.deliveryFee = payload.deliveryFee;
      }
      if (payload.condition) {
        updateObj.condition = payload.condition;
      }
      if (payload.minPeriod) {
        updateObj.minPeriod = payload.minPeriod;
      }
      if (payload.location) {
        updateObj.location = payload.location;
      }
      if (payload.area) {
        updateObj.area = payload.area;
      }
      if (payload.images) {
        updateObj.images = payload.images;
      }
      if (payload.availabilty !== null) {
        updateObj.availabilty = payload.availabilty;
      }
      // if (payload.date) {
      //   updateObj.date = payload.date;
      // }
      console.log("update obj was", updateObj);
      firebase
        .firestore()
        .collection("items")
        .doc(id)
        .update(updateObj)
        .then(async () => {
          //send email
          const callable = functions.httpsCallable("itemUpdate");
          console.log(this.user);
          const self = this;
          const response = await callable({
            email: getters.user.email,
            name: updateObj.itemName,
            id
          });
          commit("setLoading", false);
          commit("updateItem", payload);
        })
        .catch(error => {
          console.log(error);
          commit("setLoading", false);
        });
    },
    async signUserUp({ commit, context }, payload) {
      commit("setLoading", true);
      commit("clearError");
      console.log("signing up", payload)
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password).catch((error) => {
          commit("setLoading", false);
          console.log(error);
          console.log('errorCode, errorMessage', error.code, error.message);

          let errorMessage = error.message;

          let errorCode = error.code;
          errorMessage = errorMessage.replace('Firebase:', '');

          errorMessage = errorMessage.split('(')[0]

          if (errorCode === 'auth/user-not-found') {
            errorMessage = 'User not found, please sign up instead.';
          }
          if (errorCode === 'auth/wrong-password') {
            errorMessage = 'Either your password is wrong or you previously created your account with Google Signin.  Please try again.';
          }
          if (errorCode === 'auth/email-already-exists') {
            errorMessage = 'Email already exists, please login instead.';
          }
          if (errorCode === 'auth/invalid-email') {
            errorMessage = 'Email address is invalid, please try again with another email address.';
          }
          if (errorCode === 'auth/invalid-password') {
            errorMessage = 'Password is invalid, please try again with another password.  It must be a string with at least eight characters.';
          }
          if (errorCode === 'auth/network-request-failed') {
            errorMessage = 'A network error (such as timeout, interrupted connection or unreachable host) has occured.'
          }
          commit("setError", errorMessage);

        })
        .then(cred => {
          return firebase
            .firestore()
            .collection("users")
            .doc(cred.user.uid)
            .set({
              createdAt: new Date(),
              id: cred.user.uid,
              firstName: payload.firstName,
              onboarded: false,
              // suburb: payload.suburb,
              verified: false
            }).catch((error) => {
              commit("setLoading", false);
              console.log(error);
              console.log('errorCode, errorMessage', error.code, error.message);

              let errorMessage = error.message;

              let errorCode = error.code;
              errorMessage = errorMessage.replace('Firebase:', '');

              errorMessage = errorMessage.split('(')[0]

              if (errorCode === 'auth/user-not-found') {
                errorMessage = 'User not found, please sign up instead.';
              }
              if (errorCode === 'auth/wrong-password') {
                errorMessage = 'Either your password is wrong or you previously created your account with Google Signin.  Please try again.';
              }
              if (errorCode === 'auth/email-already-exists') {
                errorMessage = 'Email already exists, please login instead.';
              }
              if (errorCode === 'auth/invalid-email') {
                errorMessage = 'Email address is invalid, please try again with another email address.';
              }
              if (errorCode === 'auth/invalid-password') {
                errorMessage = 'Password is invalid, please try again with another password.  It must be a string with at least eight characters.';
              }
              if (errorCode === 'auth/network-request-failed') {
                errorMessage = 'A network error (such as timeout, interrupted connection or unreachable host) has occured.'
              }
              commit("setError", errorMessage);

            })
            .then(
              firebase
                .firestore()
                .collection("users")
                .doc(cred.user.uid)
                .collection("privateData")
                .doc(cred.user.uid)
                .set({
                  acceptPrivacyPolicy: "true",
                  acceptTermsAndConditions: "true",
                  firstName: payload.firstName,
                  id: cred.user.uid,
                  lastName: payload.lastName,
                  // phoneNumber: payload.phoneNumber,
                  verified: false,
                  // suburb: payload.suburb,
                  displayName: payload.firstName,
                  createdAt: new Date(),
                  email: payload.email
                })
            )
            .then(
              firebase
                .firestore()
                .collection("crmData")
                .doc(cred.user.uid)
                .set({
                  firstName: payload.firstName,
                  // suburb: payload.suburb,
                  id: cred.user.uid,
                  // phoneNumber: payload.phoneNumber,
                  createdAt: new Date(),
                  lastName: payload.lastName,
                  email: payload.email
                })
            ).then(() => {
              console.log('CRED:', cred);
              commit("setLoading", false);

              const newUser = {
                id: cred.user.uid,
                firstName: payload.firstName,
                // suburb: payload.suburb,
                id: cred.user.uid,
                // phoneNumber: payload.phoneNumber,
                lastName: payload.lastName,
                onboarded: false,
                email: payload.email,
                avatar: 'https://firebasestorage.googleapis.com/v0/b/strapp-4e040.appspot.com/o/users%2Favatar.png?alt=media&token=40199a7c-62e9-40bc-9089-a7771aaedefe',
              };
              console.log("Yeah buddy new user!!!!!!!!!!!!!!!!!!!!", newUser)
              commit("setUser", newUser);
              // if (user) {
              //   console.log("user here", payload);
              //   firebase.auth().currentUser.updateProfile({
              //     displayName: payload.firstName
              //   });
              //   const newUser = {
              //     id: user.user.uid,
              //     name: payload.name,
              //     surname: payload.lastName,
              //     registeredItems: [],
              //     fbKeys: {}
              //   };
              //   commit("setUser", newUser);
              // }
            })

          // .then(item => commit("CreateItem", item));
          // .then(item => commit("createBooking", item));
        });
    },
    logout({ commit }) {
      firebase.auth().signOut();
      commit("setUser", null);
    },
    signUserIn({ commit, context }, payload) {
      commit("setLoading", true);
      commit("clearError");
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          commit("setLoading", false);
          const newUser = {
            id: user.user.uid,
            registeredItems: [],
            fbKeys: {}
          };
          commit("setUser", newUser);
        })
        .catch(error => {
          commit("setLoading", false);


          console.log(error);

          console.log('errorCode, errorMessage', error.code, error.message);

          let errorMessage = error.message;

          let errorCode = error.code;
          errorMessage = errorMessage.replace('Firebase:', '');

          errorMessage = errorMessage.split('(')[0]

          if (errorCode === 'auth/user-not-found') {
            errorMessage = 'User not found, please sign up instead.';
          }
          if (errorCode === 'auth/wrong-password') {
            errorMessage = 'Either your password is wrong or you previously created your account with Google Signin.  Please try again.';
          }
          if (errorCode === 'auth/email-already-exists') {
            errorMessage = 'Email already exists, please login instead.';
          }
          if (errorCode === 'auth/invalid-email') {
            errorMessage = 'Email address is invalid, please try again with another email address.';
          }
          if (errorCode === 'auth/invalid-password') {
            errorMessage = 'Password is invalid, please try again with another password.  It must be a string with at least eight characters.';
          }
          if (errorCode === 'auth/network-request-failed') {
            errorMessage = 'A network error (such as timeout, interrupted connection or unreachable host) has occured.'
          }
          commit("setError", errorMessage);

        })
      // .then(item => commit("CreateItem", item));
    },
    autoSignIn({ commit }, payload) {
      console.log("auto sign in", payload)
      commit("setUser", {
        id: payload.uid,
        registeredItems: []
      });
    }
  },


  getters: {
    loadedBooking(state) {
      return (bookingId) => {
        return state.loadedBookings.find((booking) => {
          return booking.id === bookingId
        })
      }
    },
    reviewSuccess(state) {
      return state.reviewSuccess;
    },
    tokens(state) {
      return state.tokens;
    },
    getVerifier(state) {
      return state.verifier;
    },
    createdItemKey(state) {
      return state.createdItemKey;
    },
    loadedItems(state) {
      return state.loadedItems.sort((ItemA, ItemB) => {
        return ItemA;
      });
    },
    loadedReviews(state) {
      return state.loadedReviews;
    },
    loadedRooms(state) {
      return state.loadedRooms;

    },
    loadedUser(state) {
      return state.loadedUser;
    },
    loadedBookings(state) {
      // console.log(state)
      return state.loadedBookings;
    },
    loadedUserBookings(state) {
      // console.log(state)
      return state.loadedUserBookings;
    },
    user(state) {
      console.log('wtf???', state.user)
      return state.user;
    },
    loading(state) {
      return state.loading;
    },
    paymentSuccess(state) {
      return state.paymentSuccess;
    },
    paymentVerificationSuccess(state) {
      return state.paymentVerificationSuccess;
    },
    verificationSuccess(state) {
      return state.verificationSuccess;
    },
    error(state) {
      return state.error;
    }
  }
});
